import { compact, defaultsAll, isArray, isEmpty, map, pick } from 'lodash/fp';

import { CHANGE_EFFECTIVE_DATE, PRICE_LOAD, PRICE_LOAD_FAIL, PRICE_LOAD_SUCCESS } from '../action-types';
import getCustomerAgeBracket from '../../utils/get-customer-age-bracket';
import PriceService, { Api, PriceData } from '../../models/price';
import selectCustomer from '../../selectors/select-customer';
import type { RootState } from '../../reducers';

export type PriceActionsType = {
  changeEffectiveDate: (useFutureEffectiveDate?: boolean) => {
    type: string;
    useFutureEffectiveDate: boolean;
  };
  load: (
    productIds: string | Array<string | null>,
    data?: Record<string, unknown>,
    options?: Record<string, unknown>,
  ) => (dispatch: (action: unknown) => void, getState: () => RootState) => void;
};

function load(productIds: string | Array<string | null>, data: PriceData = {}, options: Record<string, unknown> = {}) {
  return (dispatch: (action: unknown) => void, getState: () => RootState) => {
    const globalState = getState();
    const customer = selectCustomer(data) || selectCustomer(globalState) || {};
    const ageBracket = getCustomerAgeBracket(customer);
    const productIdsArray = isArray(productIds) ? productIds : [productIds];
    const validProductIds = compact(productIdsArray);

    if (isEmpty(validProductIds)) return null;

    const conditions = pick(
      ['dependants', 'incomeTier', 'members', 'rebate', 'state', 'scale', 'starts', 'payment'],
      data,
    );

    const conditionsWithDefaults = defaultsAll([conditions, { ageBracket }, customer]);
    const keys = map((productId) => PriceService.getKey(productId, conditionsWithDefaults, options), validProductIds);

    return dispatch({
      keys,
      promise: (api: Api) => PriceService.loadPrices(api, validProductIds, conditionsWithDefaults, options),
      types: [PRICE_LOAD, PRICE_LOAD_SUCCESS, PRICE_LOAD_FAIL],
    });
  };
}

function changeEffectiveDate(useFutureEffectiveDate: boolean = false) {
  return {
    type: CHANGE_EFFECTIVE_DATE,
    useFutureEffectiveDate,
  };
}

const PriceActions: PriceActionsType = {
  changeEffectiveDate,
  load,
};

export default PriceActions;
